import {
  PACIENTE_ERROR,
  PACIENTE_SUCCESS,
  PACIENTE_LOADING,
  EDITANDO_PACIENTE,
  FINALIZAEDICION_PACIENTE,
  PACIENTE_EDITAR,
  GETDATOSPACIENTE_SUCCESS,
  RESET_PACIENTE,
  PACIENTE_LOGOUT,
  PACIENTE_CAMBIOCLAVE,
  PACIENTE_EDITACLAVE,
  PACIENTE_BIOSEGURIDAD,
  PACIENTE_BIOSEGURIDAD_ERROR,
  DROPDOWN_SELECT_USER_EDITAR_P,
  DROPDOWN_SELECT_USER_EDITAR_P_SUCCESS,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";

import pacienteInitialState from "../initialStates/pacienteInitialState";
import editaPerfilInitialState from "../initialStates/editaPerfilInitiaState";

const paciente = (state, { payload, type }) => {
  switch (type) {
    case PACIENTE_LOADING:
      return {
        ...state,
        paciente: {
          ...state.paciente,
          error: false,
          loading: true,
        },
      };
    case PACIENTE_SUCCESS:
      return {
        ...state,
        paciente: {
          ...state.paciente,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case PACIENTE_ERROR:
      return {
        ...state,
        paciente: {
          ...state.paciente,
          error: payload,
          loading: false,
        },
      };

    case EDITANDO_PACIENTE:
      return {
        ...state,
        paciente: {
          ...state.paciente,
          error: null,
          loading: false,
          editaPerfil: {
            ...state.paciente.editaPerfil,
            estado: payload,
          },
        },
      };
    case PACIENTE_EDITAR:
      return {
        ...state,
        paciente: {
          ...state.paciente,
          error: null,
          loading: false,
          editaPerfil: {
            ...state.paciente.editaPerfil,
            editarPaciente: payload,
          },
        },
      };
    case FINALIZAEDICION_PACIENTE:
      return {
        ...state,
        paciente: {
          ...state.paciente,
          error: null,
          loading: false,
          editaPerfil: editaPerfilInitialState,
        },
      };
    case GETDATOSPACIENTE_SUCCESS:
      return {
        ...state,
        paciente: {
          ...state.paciente,
          loading: false,
          error: null,
          datosActualizados: payload,
        },
      };
    case PACIENTE_CAMBIOCLAVE:
      return {
        ...state,
        paciente: {
          ...state.paciente,
          loading: false,
          error: null,
          cambioClave: payload,
        },
      };
    case PACIENTE_EDITACLAVE:
      return {
        ...state,
        paciente: {
          ...state.paciente,
          loading: false,
          error: null,
          cambioClave: payload,
        },
      };
    case PACIENTE_BIOSEGURIDAD:
      return {
        ...state,
        paciente: {
          ...state.paciente,
          loading: false,
          error: null,
          bioseguridad: payload,
        },
      };
    case PACIENTE_BIOSEGURIDAD_ERROR:
      return {
        ...state,
        paciente: {
          ...state.paciente,
          loading: false,
        },
      };
    case RESET_PACIENTE:
      return {
        ...state,
        paciente: {
          ...state.paciente,
          loading: false,
          error: null,
          data: null,
          cambioClave: null,
          editaPerfil: editaPerfilInitialState,
        },
      };

    case PACIENTE_LOGOUT:
      return pacienteInitialState;
    case RESET_PORTAL_CONTEXT:
      return pacienteInitialState;

    case DROPDOWN_SELECT_USER_EDITAR_P:
      return {
        ...state,
        paciente: {
          ...state.paciente,
          userSelect: {
            pacienteSeleccionado: payload,
          },
        },
      };

    default:
      return state;
  }
};

export default paciente;
